import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class DVCStateTreasuryObjectAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'DVCStateTreasurys';
  async getDataByCode(payload) {
    let request = { url: this.getAPIUrl() + '/getDataByCode', data: payload };

    return await httpClient.getAsync(request);
  }
}

export default new DVCStateTreasuryObjectAPI();
